import {connect} from "react-redux"
import {Row, Col} from "react-bootstrap"
import {get} from "lodash"
import React, {Component} from "react"
import PropTypes from "prop-types"

import withAuth from "@irati/auth/helpers/auth/withAuth"
import withBranding from "@irati/brand/withBranding"
import Loading from "@irati/ui/src/Loading"
import ShowPopUp from "@irati/store/actions/ShowSuccessPopUp"
import {getBannerImage} from "@irati/utils/images/getImageSize/getImageSize"
import {brand} from "@irati/ui/src/global/colors"
import tracking from "@irati-tracking/perks/perks"
import {injectIntl} from "@irati/utils/lang"
import {COMPANY_BENEFITS as DEAL_TYPE_COMPANY_BENEFITS} from "@irati/deals/constants/dealType"
import {RedemptionEventDeal} from "@irati/deals/types/enums/RedemptionEventOptions"
import {determineDealColor} from "@irati/deals/helpers/deals/appearance"
import {dobObjectToString} from "@irati/identity/utils/user/dob"

import {getVouchersFromRedemption} from "../../helpers/redemption/getVouchersFromRedemption"
import redemptionUtils from "../../helpers/redemption/redemptionUtils"
import Finished from "./Finished"
import DealSuccessTickets from "../../components/Tickets"
import FullWidthBanner from "../../components/ui/FullWidthBanner/FullWidthBanner"
import DealSEO from "../../components/DealSEO"
import OrderSummary from "../../components/DealSuccessOrderSummary"

import "./styles/DealSuccess.css"

const COMPLETE = "COMPLETE"
const USER_MENU = "usermenu"

class DealSuccess extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  static propTypes = {
    showPopUp: PropTypes.func.isRequired,
    formatMessage: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    branding: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    const load = this.getRedemptionAndDeal(get(props, "match.params.sagaUuid", null))
    this.state = {
      redemption: {},
      deal: {},
      vouchers: [],
      showPopup: false,
      allowNavigateAway: false,
      load
    }
  }

  getRedemptionAndDeal = (redemptionUuid) => {
    return redemptionUtils.getSaga(redemptionUuid, this.props.formatMessage).then((saga) => {
      const {redemption} = saga
      if (redemption.status !== COMPLETE) {
        throw new Error(this.props.formatMessage({id: "perks.containers.dealSuccess.error.notComplete"}))
      }
      this.setState({
        redemption,
        saga,
        deal: redemption.fullDeal,
        vouchers: redemption.order ? getVouchersFromRedemption(redemption) : []
      })
    })
  }

  componentDidMount() {
    /**
     * Fix scroll position sticking from previous page on smaller screens
     */
    window.scrollTo(0, 0)
    if (!localStorage.getItem(`${USER_MENU}TooltipHide`)) {
      const {formatMessage} = this.props

      const tooltip = {
        show: true,
        text: formatMessage({id: "perks.containers.dealSuccess.dealSuccess.tooltipText"}),
        subtext: formatMessage({id: "perks.containers.dealSuccess.dealSuccess.tooltip.subText"}),
        color: "#1EBCB2",
        anchor: USER_MENU,
        triangle: "right"
      }
      this.props.showPopUp(tooltip)
      setTimeout(() => {
        this.props.showPopUp({show: false})
      }, 10000)
    }
  }

  componentDidUpdate() {
    const {deal} = this.state
    const {
      auth: {user}
    } = this.props

    const dealUuid = get(deal, "uuid", null)

    if (dealUuid && dealUuid === RedemptionEventDeal.BirthdayBox) {
      tracking.redeemBirthdayBoxPerkComplete(dobObjectToString(user.dateOfBirth))
    }
  }

  componentWillUnmount() {
    this.props.showPopUp({show: false})
  }

  render() {
    const {redemption, deal, vouchers, load} = this.state
    const {branding} = this.props
    const isCompanyBenefit = deal.type === DEAL_TYPE_COMPANY_BENEFITS

    const tenantImage = branding.businessLogoUrl
    const brandColor = determineDealColor(deal, tenantImage, brand.default)

    return (
      <div>
        <Loading load={load}>
          <DealSEO deal={deal} pageTitle={this.props.formatMessage({id: "perks.containers.dealSuccess.dealSuccess.dealSEO.pageTitle"})} />
          <FullWidthBanner
            useImgTag={!isCompanyBenefit}
            src={isCompanyBenefit ? null : getBannerImage(deal.bannerImage)}
            alt={deal.header}
            color={brandColor} />
          <Row className="dealSuccess">
            <Col md={12}>
              <DealSuccessTickets deal={deal} redemption={redemption} vouchers={vouchers}>
                {get(redemption.order, "total.value", 0) > 0 && <OrderSummary order={redemption.order} deal={deal} />}
              </DealSuccessTickets>
            </Col>
          </Row>
        </Loading>
        <Finished />
      </div>
    )
  }
}

export const DealSuccessUnconnected = DealSuccess

const mapDispatchToProps = (dispatch) => {
  return {
    showPopUp: (details) => dispatch(ShowPopUp(details))
  }
}

export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(withAuth(withBranding(DealSuccess)))
)
